var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_874_147186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.217773,
    y: 0.984375,
    width: 16.4,
    height: 16.4,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_874_147186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.36758 13.2839C5.99174 13.2839 5.67012 13.1502 5.40271 12.8828C5.13484 12.6149 5.00091 12.2931 5.00091 11.9173V3.71725C5.00091 3.34142 5.13484 3.01957 5.40271 2.7517C5.67012 2.48429 5.99174 2.35059 6.36758 2.35059H12.5176C12.8934 2.35059 13.2153 2.48429 13.4831 2.7517C13.7505 3.01957 13.8842 3.34142 13.8842 3.71725V11.9173C13.8842 12.2931 13.7505 12.6149 13.4831 12.8828C13.2153 13.1502 12.8934 13.2839 12.5176 13.2839H6.36758ZM3.63424 16.0173C3.25841 16.0173 2.93656 15.8835 2.66869 15.6161C2.40128 15.3483 2.26758 15.0264 2.26758 14.6506V5.76725C2.26758 5.57364 2.33318 5.41124 2.46438 5.28004C2.59512 5.14929 2.7573 5.08392 2.95091 5.08392C3.14452 5.08392 3.30693 5.14929 3.43813 5.28004C3.56887 5.41124 3.63424 5.57364 3.63424 5.76725V14.6506H10.4676C10.6612 14.6506 10.8236 14.7162 10.9548 14.8474C11.0855 14.9781 11.1509 15.1403 11.1509 15.3339C11.1509 15.5275 11.0855 15.6897 10.9548 15.8205C10.8236 15.9517 10.6612 16.0173 10.4676 16.0173H3.63424Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fd67ca49ce204c74b4f8c14440309b7a.svg";
export { ForwardRef as ReactComponent };